import { Link, Typography } from '@material-ui/core'
import styled from 'styled-components'

export const HelpIcon = styled.img`
  margin: 2px 0 0 0;
  padding: 0;
  width: 15px;
  height: 15px;
`

export const StyledLink = styled(Link)`
  display: flex;
  flex-direction: column;
  padding: 10px 14px 10px 14px;
`

export const HintText = styled(Typography)(({ theme }) => ({
  '&.MuiTypography-root': {
    color: theme?.colors?.brand?.white || '#FFF',
    textAlign: 'center',
    padding: '10px 14px 10px 14px',
    pointerEvents: 'none',
  },
}))

export const LinkContent = styled(Typography)(({ theme }) => ({
  '&.MuiTypography-root': {
    color: theme?.colors?.brand?.white || '#FFF',
    textAlign: 'center',
  },
}))

export const LinkText = styled(Typography)(({ theme }) => ({
  '&.MuiTypography-root': {
    color: theme?.colors?.brand?.white || '#FFF',
    marginTop: '5px',
    textAlign: 'center',
    fontWeight: 600,
    pointerEvents: 'none',
  },
}))
